import classNames from "classnames";

export interface FriendData {
  losses: number;
  time_played: number;
  total_games: number;
  username: string;
  img: string;
  lp: number;
  wins: number;
}

interface TeamPlayersProps {
  playerData: FriendData;
  children?: React.ReactNode;
  className?: string;
}

interface TeamPlayersModuleProps {
  friendData: FriendData[]; // The component accepts an object with a property named 'friendData'
}

export const TeamPlayerSection = (data: TeamPlayersProps) => {
  {
    const winrate = Math.round((data.playerData.wins / data.playerData.total_games) * 100);
    const winning = data.playerData.lp > 0;
    return (
      <div className="w-[240px] h-[210px] mr-[9px] ml-[9px] pt-[39px]">
        <div
          className={classNames("relative  w-[238px] h-[169px] shrink-0 border-t border-t-[1px]", {
            "bg-[linear-gradient(179deg,rgba(50,115,250,0.10)_0.48%,rgba(50,115,250,0)_99.49%)] border-t-[#3273FA]": winning,
            "bg-[linear-gradient(179deg,rgba(255,70,85,0.10)_0.48%,rgba(255,70,85,0)_99.49%)] border-t-[#FF4655]": !winning,
          })}
        >
          <div className="flex items-center justify-center [left:calc(50%-35px)] top-[-35px] absolute w-[70px] h-[70px] shrink-0 rounded-full border-2 border-[#F4C874] bg-[#070720] outline outline-[3px] outline-[#070720]">
            <img
              src={data.playerData.img}
              alt="User Profile Icon"
              className="top-[3px] left-[3px] w-[63.978px] h-[63.978px] shrink-0 rounded-full bg-#070720 bg-center bg-cover bg-no-repeat"
            ></img>
          </div>
          <div className="mt-[43px] text-[#F4C874] text-center font-[Barlow] text-[20px] font-semibold leading-normal uppercase">
            {data.playerData.username}
          </div>
          <div
            className={classNames(
              "text-center [text-shadow:0_2px_2px_rgba(0,0,0,0.40)] font-[Barlow] text-[30px] italic font-medium leading-normal uppercase",
              {
                "text-[#3273FA]": winning,
                "text-[#FF4655]": !winning,
              },
            )}
          >
            {data.playerData.lp} LP
          </div>
          <div className="text-white text-center font-[Barlow] text-[18px] italic font-bold leading-normal">{winrate}% WR</div>
          <div className="flex justify-center text-[#CDDCFE] text-center font-[Barlow] text-[12px] italic font-medium leading-normal">
            {data.playerData.wins}W
            <div className="text-[#383864] font-[Barlow] text-[12px] italic font-medium leading-normal"> / </div>
            {data.playerData.losses}L
          </div>
        </div>
      </div>
    );
  }
};

export function TeamPlayersModule({ friendData }: TeamPlayersModuleProps) {
  return (
    <div className="flex flex-col md:flex-row">
      {friendData.map((friend) => {
        return <TeamPlayerSection key={friend.username} playerData={friend}></TeamPlayerSection>;
      })}
    </div>
  );
}
